import { ensureUser, fetchMatchPointsInfo } from './user';
import { ensurePwaManifestLink } from './pwa-manifest';

ensurePwaManifestLink();

type Lesson = {
  id: string;
  title: string;
  desc: string;
};

const LESSONS: ReadonlyArray<Lesson> = [
  {
    id: 'yaojiu',
    title: '幺九（第 1 关）',
    desc: '自摸胡：每一个刻子、顺子、将都包含 1 或 9（本关直接进入打牌阶段）',
  },
];

function render(): void {
  const root = document.getElementById('coach-root');
  if (!root) {
    throw new Error('Missing #coach-root');
  }

  root.innerHTML = '';

  const header = document.createElement('div');
  header.className = 'mb-3';
  header.innerHTML = `
    <div class="h4 mb-1">教练模式</div>
    <div class="text-white-50">单人学习（其他三家由脚本控制），建议横屏体验。</div>
  `;
  root.appendChild(header);

  const list = document.createElement('div');
  list.className = 'd-flex flex-column gap-2';
  root.appendChild(list);

  for (const lesson of LESSONS) {
    const card = document.createElement('div');
    card.className = 'p-3 rounded bg-dark border border-secondary';

    const title = document.createElement('div');
    title.className = 'h5 mb-1';
    title.textContent = lesson.title;

    const desc = document.createElement('div');
    desc.className = 'text-white-50 mb-2';
    desc.textContent = lesson.desc;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btn btn-warning btn-sm';
    btn.textContent = '开始';
    btn.onclick = () => void (async () => {
      btn.disabled = true;
      try {
        await ensureUser();
        const points = await fetchMatchPointsInfo();
        if (points.matchPoints <= 0) {
          window.alert('对局积分不足（0），无法开始教练模式。请先回首页领取每日 4000 积分。');
          return;
        }
      } catch (err: unknown) {
        window.alert(`账号校验失败：${String((err as any)?.message ?? err)}`);
        return;
      } finally {
        btn.disabled = false;
      }
      // Use an absolute path so it works for both `/coach` and `/coach/`.
      window.location.href = `/coach/hand/?lesson=${encodeURIComponent(lesson.id)}`;
    })();

    card.appendChild(title);
    card.appendChild(desc);
    card.appendChild(btn);
    list.appendChild(card);
  }

  const footer = document.createElement('div');
  footer.className = 'mt-3 text-white-50 small';
  footer.textContent = '提示：教练模式为调试/教学用，不影响正常四人对战 /hand/。';
  root.appendChild(footer);
}

render();
